<template>
	<div class="useri_right">
			<div class="useri_right_pad">
				<div class="userirp_d1"><span></span>修改密码</div>
				<el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
					<el-form-item label="旧密码" prop="age">
						<el-input class="userirp_d1_inp" v-model="ruleForm.age" autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item label="新密码" prop="pass">
						<el-input class="userirp_d1_inp" type="password" v-model="ruleForm.pass" autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item label="确认密码" prop="checkPass">
						<el-input class="userirp_d1_inp" type="password" v-model="ruleForm.checkPass" autocomplete="off"></el-input>
					</el-form-item>

					<el-form-item>
						<el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
						<el-button @click="resetForm('ruleForm')">重置</el-button>
					</el-form-item>
				</el-form>
			</div>

		</div>
</template>

<script>
	export default {

		data() {
			var checkAge = (rule, value, callback) => {
				if (!value) {
					return callback(new Error('旧密码不能为空'));
				}
				callback();
			};
			var validatePass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入新密码'));
				}else if(value.length < 6){
					callback(new Error('新密码长度过低'));
				}else if(value == this.ruleForm.age){
					callback(new Error('新密码不能与旧密码一致'));
				} else {
					if (this.ruleForm.checkPass !== '') {
						this.$refs.ruleForm.validateField('checkPass');
					}
					callback();
				}
			};
			var validatePass2 = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请再次输入密码'));
				} else if (value !== this.ruleForm.pass) {
					callback(new Error('两次输入密码不一致!'));
				} else {
					callback();
				}
			};
			return {
				ruleForm: {
					pass: '',
					checkPass: '',
					age: ''
				},
				rules: {
					pass: [{
						validator: validatePass,
						trigger: 'blur'
					}],
					checkPass: [{
						validator: validatePass2,
						trigger: 'blur'
					}],
					age: [{
						validator: checkAge,
						trigger: 'blur'
					}]
				}
			}
		},
		computed: {

		},
		watch: {

		},
		created: function() {
			
		},
		mounted: function() {

		},
		methods: {
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						var that = this
						that.$post('SetPwd', {
								UserId: that.$store.state.userId,
								NewPwd:that.ruleForm.pass,
								OldPwd:that.ruleForm.age
							})
							.then(function(res) {
								if(res.data.Success == "true"){
									that.$message({
										message: res.data.Msg,
										type: 'success'
									});
									that.ruleForm = {
										pass: '',
										checkPass: '',
										age: ''
									}
									that.$store.state.delCookie("userId")
									that.$store.state.delCookie("userPhone")
									that.$store.state.userId = ""
									that.$router.push("/login")
								}else{
									that.$message.error(res.data.Msg);
								}
							})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			},
			toPwd() {
				this.$router.push("/setPwd")
			},
			toAddress() {
				this.$router.push("/address")
			},
			toOrderList(){
				this.$router.push("/orderList")
			},
			toFast(){
				this.$router.push("/fast")
			},
			toSetPwd(){
				this.$router.push("/setPwd")
			},
			toUserInfo(){
				this.$router.push("/userInfo")
			},
			toCar(){
				this.$router.push("/car")
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >

</style>
